import {ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AbstractVisbosControl} from "../../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {Stocktaking} from "../../../model/stocktaking";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SessionActions} from "../../../../shared/actions";
import {DepotStocktakingComponent} from "../depot-stocktaking-form/depot-stocktaking.component";
import {appInjector} from "../../../../";
import {GERMAN_LAYOUT} from "../../../../core/visbos-core/ui/directives/on-screen-keyboard.directive";
import {KeyboardOptions} from "virtual-keyboard";

@Component({
  selector: 'vb-stocktaking-form',
  templateUrl: './stocktaking-form.component.html',
  styleUrls: ['./stocktaking-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => StocktakingFormComponent)}]
})
export class StocktakingFormComponent extends AbstractVisbosControl<Stocktaking, FormGroup> implements OnInit {

  kbOptions: KeyboardOptions = {
    type: 'input',
    layout: 'custom',
    customLayout: GERMAN_LAYOUT
  };

  @Input()
  touchMode: boolean = false;

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public buildControlContent(values?: Stocktaking, ...params: any[]): FormGroup {
    return StocktakingFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      stocktaking_type_id: [null, Validators.required],
      administration_unit_id: [null, Validators.required],
      description: [null],
      notes: [null],
      involved_persons_names: [null]
    });

  }

  public setDefaultValues(item?: Stocktaking): { [controlKey: string]: any } | any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      stocktaking_type_id: this.setValue(item, 'stocktaking_type.cuid'),
      administration_unit_id: this.setValue(item, 'administration_unit.cuid', this.activeAdminUnitCuid),
      description: this.setValue(item, 'description'),
      notes: this.setValue(item, 'notes'),
      involved_persons_names: this.setValue(item, 'persons'),
    }
  };

}



// WEBPACK FOOTER //
// ./src/app/store-management/stocktaking/components/stocktaking-form/stocktaking-form.component.ts